import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { metricsAtom } from '@/atoms/metric';
import { GenericToast } from '@/components/alerts/GenericToast/GenericToast';
import { AsideContent } from './AsideContent';
import { MainContent } from './MainContent';
import { MetricLimitsAsideContent } from './MetricLimitsAsideContent';
import { MetricLimitsMainContent } from './MetricLimitsMainContent';

const translations = 'createRadarTemplateModal.step3';

export const MetricLimits = () => {
  const { t } = useTranslation(['modal', 'general', 'metrics']);
  const selectedMetrics = useAtomValue(metricsAtom);

  return (
    <>
      <MainContent title={t(`${translations}.title`)} description={t(`${translations}.description`)}>
        <MetricLimitsMainContent />
      </MainContent>
      <AsideContent
        title={t(`${translations}.aside`, { count: selectedMetrics.length })}
        withOptionsMenu={false}
        className="hidden md:flex"
      >
        <MetricLimitsAsideContent />
      </AsideContent>
      <GenericToast />
    </>
  );
};
